import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { TrendingUp } from "lucide-react";

export default function CandidateStats() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/analytics/candidate").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  const cards = [
    { key: "applications", label: "Candidatures", value: data.totals.applications },
    { key: "response-rate", label: "Taux de réponse", value: `${data.response_rate}%` },
    { key: "interviews", label: "Entretiens à venir", value: data.totals.interviews_upcoming },
    { key: "saved", label: "Offres sauvegardées", value: data.totals.saved_offers },
  ];

  return (
    <div data-testid="candidate-stats" className="bg-white rounded-xl border border-slate-200 p-6">
      <h2 className="font-semibold text-brand-navy mb-4 flex items-center gap-2">
        <TrendingUp className="w-5 h-5 text-brand-turquoise" />
        Mes statistiques
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {cards.map((c) => (
          <div key={c.key} data-testid={`candidate-stat-${c.key}`} className="bg-slate-50 rounded-lg p-4">
            <p className="text-2xl font-bold text-brand-navy">{c.value}</p>
            <p className="text-xs text-slate-500 mt-1">{c.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
